import i18n from "@gik/i18n";
import { translationKeys } from "@gik/inkind-page/i18n/en";
import type InkindUserUpdate from "@gik/inkind-page/models/InkindUserUpdate";
import { ModalButtonFooter } from "@gik/ui-legacy/Modal";
import type { UIGenericDialogOptions } from "@gik/ui-legacy/UIManager";
import { UI } from "@gik/ui-legacy/UIManager";
import AddEditInkindUserUpdatesModal from "../components/AddEditInkindUserUpdatesModal/AddEditInkindUserUpdatesModal";

export function showPageDeactivatedModal(): Promise<boolean> {
	return UI.alert(
		<div>
			<p>Please give our system up to 10 minutes to complete the removal of your InKind Page.</p>
			<p>Your Page can be reactivated by Customer Support at any time.</p>
		</div>,
		{ title: 'Page Deactivated' }
	);
}

export type openAddEditUpdateModalProps = {
	inkindRouteId: string;
	selectedUpdate?: InkindUserUpdate;
	options?: UIGenericDialogOptions;
	onSuccess?: () => void;
};

export function openAddEditUpdateModal({
	inkindRouteId,
	selectedUpdate,
	options,
	onSuccess,
}: openAddEditUpdateModalProps) {
	return UI.dialog(
		({ close, footerRef }) => {
			return (
				<AddEditInkindUserUpdatesModal
					buttonsPortal={footerRef}
					routeId={inkindRouteId}
					selectedUpdate={selectedUpdate}
					onClose={() => {
						close();
						onSuccess?.();
					}}
				/>
			);
		},

		{
			title: i18n.t(
				selectedUpdate
					? translationKeys.EditUpdateButtonLabel
					: translationKeys.AddUpdateButtonLabel,
			),
			closable: true,
			footer: <ModalButtonFooter />,
			...options,
		},
	);
}
